import React from "react";

export { LoadingState, TableLoadingSkeleton, CardLoadingSkeleton } from "./LoadingState";

export function PageHeader({ overline, title, description, actions }) {
    return (
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8">
            <div>
                {overline && <p className="text-xs font-semibold uppercase tracking-overline text-brand-action">{overline}</p>}
                <h1 className="font-heading font-bold text-3xl lg:text-4xl tracking-tight text-brand-ink mt-1">{title}</h1>
                {description && <p className="text-brand-inkSoft mt-2 max-w-xl leading-relaxed">{description}</p>}
            </div>
            {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
        </div>
    );
}

export function StatCard({ label, value, hint, accent, testId }) {
    return (
        <div data-testid={testId} className="bg-white border border-brand-line rounded-lg p-6 hover:shadow-md hover:border-brand-action/30 transition-all duration-200 h-full">
            <p className="text-[10px] font-semibold uppercase tracking-overline text-brand-inkSoft">{label}</p>
            <p className={`font-heading font-bold text-3xl tracking-tight mt-3 ${accent ? "text-brand-action" : "text-brand-ink"}`}>{value}</p>
            {hint && <p className="text-xs text-brand-inkSoft mt-2">{hint}</p>}
        </div>
    );
}

export function EmptyState({ title, description, image, action }) {
    return (
        <div className="border border-dashed border-brand-line rounded-lg bg-white p-10 text-center">
            {image && <img src={image} alt="" className="mx-auto max-h-40 rounded-lg object-cover mb-6 opacity-90" />}
            <h3 className="font-heading font-semibold text-xl text-brand-ink">{title}</h3>
            {description && <p className="text-brand-inkSoft mt-2 max-w-md mx-auto">{description}</p>}
            {action && <div className="mt-6">{action}</div>}
        </div>
    );
}

export function Chip({ children, variant = "default", ...rest }) {
    const styles = {
        default: "bg-brand-bg text-brand-inkSoft border border-brand-line",
        warn: "bg-[#FFF7ED] text-[#EA580C] border border-[#FFEDD5]",
        success: "bg-[#ECFDF5] text-[#059669] border border-[#A7F3D0]",
        danger: "bg-[#FEF2F2] text-[#DC2626] border border-[#FECACA]",
        neutral: "bg-[#F3F4F6] text-[#4B5563] border border-[#E5E7EB]",
    };
    return (
        <span {...rest} className={`inline-flex items-center rounded-full text-[10px] font-semibold uppercase tracking-overline px-2.5 py-1 ${styles[variant] || styles.default}`}>
            {children}
        </span>
    );
}
